(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.standalone = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('../utils');

var ERROR_KEYS = (0, _utils.freeze)({
  /**
   * @memberof module:ist~ERROR_KEYS
   * 
   * @example
   * ANY: {
   *  UNKNOWN: 'any.unknown',
   *  REQUIRED: 'any.required',
   *  ALLOW: 'any.allow',
   * }
   */
  ANY: {
    UNKNOWN: 'any.unknown',
    REQUIRED: 'any.required',
    ALLOW: 'any.allow'
  },
  /**
   * @memberof module:ist~ERROR_KEYS
   * 
   * @example
   * 
   * NUMBER: {
   *  TYPE: 'number.type',
   *  GE: 'number.ge',
   *  GT: 'number.gt',
   *  LE: 'number.le',
   *  LT: 'number.lt',
   *  RANGE: 'number.range',
   * }
   * 
   */
  NUMBER: {
    TYPE: 'number.type',
    GE: 'number.ge',
    GT: 'number.gt',
    LE: 'number.le',
    LT: 'number.lt',
    RANGE: 'number.range'
  },
  /**
   * @memberof module:ist~ERROR_KEYS
   * 
   * @example
   * 
   * STRING: {
   *  EMPTY: 'string.empty',
   *  TYPE: 'string.type',
   *  EMAIL: 'string.email',
   *  MATCH: 'string.match',
   *  DIGITS: 'string.digits',
   *  ALPHANUM: 'string.alphanum',
   *  ISO_DATE: 'string.iso.date',
   * }
   * 
   */
  STRING: {
    EMPTY: 'string.empty',
    TYPE: 'string.type',
    EMAIL: 'string.email',
    MATCH: 'string.match',
    DIGITS: 'string.digits',
    ALPHANUM: 'string.alphanum',
    ISO_DATE: 'string.iso.date'
  },
  /**
   * @memberof module:ist~ERROR_KEYS
   * 
   * @example
   * 
   * BOOLEAN: {
   *  TYPE: 'boolean.type',
   * }
   * 
   */
  BOOLEAN: {
    TYPE: 'boolean.type'
  },
  /**
   * @memberof module:ist~ERROR_KEYS
   * 
   * @example
   * 
   * SHAPE: {
   *  TYPE: 'shape.type',
   *  ALLOWED_KEYS: 'shape.allowed.keys',
   *  FORBIDDEN_KEYS: 'shape.forbidden.keys',
   *  EXPECTED_KEYS: 'shape.expected.keys',
   * }
   * 
   */
  SHAPE: {
    TYPE: 'shape.type',
    ALLOWED_KEYS: 'shape.allowed.keys',
    FORBIDDEN_KEYS: 'shape.forbidden.keys',
    EXPECTED_KEYS: 'shape.expected.keys'
  },
  /**
   * @memberof module:ist~ERROR_KEYS
   * 
   * @example
   * 
   * ARRAY: {
   *  TYPE: 'array.type',
   *  MIN_LENGTH: 'array.min.length',
   *  MAX_LENGTH: 'array.max.length',
   *  IN_RANGE: 'array.range',
   *  LENGTH: 'array.exact.length',
   *  EVERY: 'array.every',
   *  SOME: 'array.some',
   * }
   * 
   */
  ARRAY: {
    TYPE: 'array.type',
    MIN_LENGTH: 'array.min.length',
    MAX_LENGTH: 'array.max.length',
    IN_RANGE: 'array.range',
    LENGTH: 'array.exact.length',
    EVERY: 'array.every',
    SOME: 'array.some'
  }
}); /** @module ist */
/** @namespace module:ist~ERROR_KEYS */
exports.default = ERROR_KEYS;

},{"../utils":6}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Object$freeze;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /** @module ist */
/** @namespace module:ist~ERROR_MESSAGES */


var _keys = require('./keys');

var _keys2 = _interopRequireDefault(_keys);

var _like = require('../like.lodash');

var _like2 = _interopRequireDefault(_like);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ANY = _keys2.default.ANY,
    NUMBER = _keys2.default.NUMBER,
    STRING = _keys2.default.STRING,
    BOOLEAN = _keys2.default.BOOLEAN,
    SHAPE = _keys2.default.SHAPE,
    ARRAY = _keys2.default.ARRAY;


var MESSAGES = Object.freeze((_Object$freeze = {}, _defineProperty(_Object$freeze, ANY.UNKNOWN, function (_ref) {
  var label = _ref.label;
  return label + ' contains errors';
}), _defineProperty(_Object$freeze, ANY.REQUIRED, function (_ref2) {
  var label = _ref2.label;
  return label + ' is required';
}), _defineProperty(_Object$freeze, ANY.ALLOW, function (_ref3) {
  var label = _ref3.label,
      args = _ref3.args;
  return label + ' should be one of allowed values: ' + args.join(', ');
}), _defineProperty(_Object$freeze, NUMBER.TYPE, function (_ref4) {
  var label = _ref4.label;
  return label + ' should be a number';
}), _defineProperty(_Object$freeze, NUMBER.GT, function (_ref5) {
  var label = _ref5.label,
      args = _ref5.args;
  return label + ' should be greater than ' + args;
}), _defineProperty(_Object$freeze, NUMBER.LT, function (_ref6) {
  var label = _ref6.label,
      args = _ref6.args;
  return label + ' should be lower than ' + args;
}), _defineProperty(_Object$freeze, NUMBER.GE, function (_ref7) {
  var label = _ref7.label,
      args = _ref7.args;
  return label + ' should be greater or equal than ' + args;
}), _defineProperty(_Object$freeze, NUMBER.LE, function (_ref8) {
  var label = _ref8.label,
      args = _ref8.args;
  return label + ' should be lower or equal than ' + args;
}), _defineProperty(_Object$freeze, NUMBER.RANGE, function (_ref9) {
  var label = _ref9.label,
      _ref9$args = _slicedToArray(_ref9.args, 2),
      min = _ref9$args[0],
      max = _ref9$args[1];

  return label + ' should be lower than ' + max + ' and greater or equal ' + min;
}), _defineProperty(_Object$freeze, STRING.EMPTY, function (_ref10) {
  var label = _ref10.label;
  return label + ' should not be blank';
}), _defineProperty(_Object$freeze, STRING.TYPE, function (_ref11) {
  var label = _ref11.label;
  return label + ' should be a string';
}), _defineProperty(_Object$freeze, STRING.MATCH, function (_ref12) {
  var label = _ref12.label,
      args = _ref12.args;
  return label + ' should match the pattern ' + args;
}), _defineProperty(_Object$freeze, STRING.EMAIL, function (_ref13) {
  var label = _ref13.label;
  return label + ' should be a valid email address';
}), _defineProperty(_Object$freeze, STRING.DIGITS, function (_ref14) {
  var label = _ref14.label;
  return label + ' should contain only digits';
}), _defineProperty(_Object$freeze, STRING.ALPHANUM, function (_ref15) {
  var label = _ref15.label;
  return label + ' should contain only alphanumeric characters';
}), _defineProperty(_Object$freeze, STRING.ISO_DATE, function (_ref16) {
  var label = _ref16.label;
  return label + ' should be an ISO Date';
}), _defineProperty(_Object$freeze, BOOLEAN.TYPE, function (_ref17) {
  var label = _ref17.label;
  return label + ' should be a boolean';
}), _defineProperty(_Object$freeze, SHAPE.TYPE, function (_ref18) {
  var label = _ref18.label;
  return label + ' should be an object';
}), _defineProperty(_Object$freeze, SHAPE.ALLOWED_KEYS, function (_ref19) {
  var label = _ref19.label,
      value = _ref19.value,
      args = _ref19.args;

  var keys = _like2.default.keys(value).join(', ') || 'no keys';
  return label + ' contains: ' + keys + ', but should contain only keys: ' + args.join(', ');
}), _defineProperty(_Object$freeze, SHAPE.EXPECTED_KEYS, function (_ref20) {
  var label = _ref20.label,
      value = _ref20.value,
      args = _ref20.args;

  var keys = _like2.default.keys(value).join(', ') || 'no keys';
  return label + ' contains: ' + keys + ', but should have keys: ' + args.join(', ');
}), _defineProperty(_Object$freeze, SHAPE.FORBIDDEN_KEYS, function (_ref21) {
  var label = _ref21.label,
      args = _ref21.args;
  return label + ' contains forbidden keys: ' + args.join(', ');
}), _defineProperty(_Object$freeze, ARRAY.TYPE, function (_ref22) {
  var label = _ref22.label;
  return label + ' should be an array';
}), _defineProperty(_Object$freeze, ARRAY.LENGTH, function (_ref23) {
  var label = _ref23.label,
      args = _ref23.args;
  return label + ' should have ' + args + ' items';
}), _defineProperty(_Object$freeze, ARRAY.MIN_LENGTH, function (_ref24) {
  var label = _ref24.label,
      args = _ref24.args;
  return label + ' should have at least ' + args + ' items';
}), _defineProperty(_Object$freeze, ARRAY.MAX_LENGTH, function (_ref25) {
  var label = _ref25.label,
      args = _ref25.args;
  return label + ' should have at most ' + args + ' items';
}), _defineProperty(_Object$freeze, ARRAY.IN_RANGE, function (_ref26) {
  var label = _ref26.label,
      _ref26$args = _slicedToArray(_ref26.args, 2),
      min = _ref26$args[0],
      max = _ref26$args[1];

  return label + ' should have length between ' + min + ' and ' + max;
}), _defineProperty(_Object$freeze, ARRAY.SOME, function (_ref27) {
  var label = _ref27.label;
  return label + ' should have at least one item that follows the rule';
}), _defineProperty(_Object$freeze, ARRAY.EVERY, function (_ref28) {
  var label = _ref28.label;
  return label + ' items should follow the rule';
}), _Object$freeze));

exports.default = MESSAGES;

},{"../like.lodash":4,"./keys":1}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERROR_MESSAGES = exports.ERROR_KEYS = exports.toValidatorWithArgs = exports.toValidator = exports.createValidateFunction = exports.validateAllWithOpts = exports.validateAll = exports.validateWithOpts = exports.validate = exports.isInvalid = exports.isValid = exports.spec = exports.validators = undefined;

var _specification = require('./specification');

var _specification2 = _interopRequireDefault(_specification);

var _validate = require('./validate');

var _validate2 = _interopRequireDefault(_validate);

var _validators = require('./validators');

var _validators2 = _interopRequireDefault(_validators);

var _utils = require('./utils');

var _keys = require('./defaults/keys');

var _keys2 = _interopRequireDefault(_keys);

var _messages = require('./defaults/messages');

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isValid = _validate2.default.isValid,
    isInvalid = _validate2.default.isInvalid,
    validate = _validate2.default.validate,
    validateWithOpts = _validate2.default.validateWithOpts,
    validateAll = _validate2.default.validateAll,
    validateAllWithOpts = _validate2.default.validateAllWithOpts,
    createValidateFunction = _validate2.default.createValidateFunction;
exports.validators = _validators2.default;
exports.spec = _specification2.default;
exports.isValid = isValid;
exports.isInvalid = isInvalid;
exports.validate = validate;
exports.validateWithOpts = validateWithOpts;
exports.validateAll = validateAll;
exports.validateAllWithOpts = validateAllWithOpts;
exports.createValidateFunction = createValidateFunction;
exports.toValidator = _utils.toValidator;
exports.toValidatorWithArgs = _utils.toValidatorWithArgs;
exports.ERROR_KEYS = _keys2.default;
exports.ERROR_MESSAGES = _messages2.default;

},{"./defaults/keys":1,"./defaults/messages":2,"./specification":5,"./utils":6,"./validate":7,"./validators":11}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var flow = exports.flow = function flow() {
  for (var _len = arguments.length, fncs = Array(_len), _key = 0; _key < _len; _key++) {
    fncs[_key] = arguments[_key];
  }

  return function (value) {
    return fncs.reduce(function (result, fn) {
      return fn(result);
    }, value);
  };
};
var curry = exports.curry = function curry(fn) {
  var currierX = function currierX() {
    for (var _len2 = arguments.length, xargs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      xargs[_key2] = arguments[_key2];
    }

    var currierY = function currierY() {
      for (var _len3 = arguments.length, yargs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        yargs[_key3] = arguments[_key3];
      }

      var fullArgs = [].concat(xargs, yargs);

      if (fn.length <= fullArgs.length) {
        return fn.apply(undefined, _toConsumableArray(fullArgs));
      }

      return currierX.apply(undefined, _toConsumableArray(fullArgs));
    };

    if (fn.length <= xargs.length) {
      return fn.apply(undefined, xargs);
    }

    return currierY;
  };

  return currierX;
};

var isNumber = exports.isNumber = function isNumber(value) {
  return typeof value === 'number';
};
var isBoolean = exports.isBoolean = function isBoolean(value) {
  return typeof value === 'boolean';
};
var isString = exports.isString = function isString(value) {
  return typeof value === 'string';
};
var isObject = exports.isObject = function isObject(value) {
  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null;
};
var isFunction = exports.isFunction = function isFunction(value) {
  return typeof value === 'function';
};
var isArray = exports.isArray = function isArray(value) {
  return Array.isArray(value);
};
var isEmpty = exports.isEmpty = function isEmpty(value) {
  if (value == null) {
    return true;
  }

  return Object.keys(value).length === 0;
};

var identity = exports.identity = function identity(v) {
  return v;
};
var every = exports.every = curry(function (predicate, value) {
  if (isArray(value)) {
    return Array.prototype.every.call(value, predicate);
  }

  return true;
});

var some = exports.some = curry(function (predicate, value) {
  if (isArray(value)) {
    return Array.prototype.some.call(value, predicate);
  }

  return true;
});

var reverse = exports.reverse = function reverse(value) {
  return Array.prototype.reverse.call(value);
};
var assign = exports.assign = function assign(a, b) {
  return Object.assign(a, b);
};
var keys = exports.keys = function keys(value) {
  return Object.keys(value);
};
var entries = exports.entries = function entries(value) {
  return Object.entries(value);
};
var stubTrue = exports.stubTrue = function stubTrue() {
  return true;
};
var includes = exports.includes = function includes(value, args) {
  return Array.prototype.includes.call(args, value);
};
var cond = exports.cond = function cond(rules) {
  return function (value) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = rules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _ref = _step.value;

        var _ref2 = _slicedToArray(_ref, 2);

        var predicate = _ref2[0];
        var action = _ref2[1];

        if (predicate(value)) {
          return action(value);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  };
};

var get = exports.get = curry(function (path, value) {
  if (value == null) {
    return undefined;
  }

  if (value.hasOwnProperty(path)) {
    return value[path];
  }

  var stage = value;
  var pathParts = path.split('.');

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = pathParts[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var part = _step2.value;

      if (isObject(stage)) {
        stage = stage[part];
        continue;
      }

      return undefined;
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return stage;
});

var getOr = exports.getOr = function getOr(defValue, path) {
  return function (value) {
    var result = get(path, value);
    return result === undefined ? defValue : result;
  };
};

var overArgs = exports.overArgs = function overArgs(transform, fnsFlow) {
  return function () {
    var results = [];

    for (var i = 0, l = arguments.length; i < l; i += 1) {
      var fn = fnsFlow[i] || identity;
      results.push(fn(arguments.length <= i ? undefined : arguments[i]));
    }

    return transform.apply(undefined, results);
  };
};

exports.default = {
  flow: flow,
  curry: curry,
  assign: assign,
  cond: cond,
  entries: entries,
  every: every,
  some: some,
  get: get,
  getOr: getOr,
  identity: identity,
  includes: includes,
  keys: keys,
  overArgs: overArgs,
  reverse: reverse,
  stubTrue: stubTrue,
  isEmpty: isEmpty,
  isArray: isArray,
  isNumber: isNumber,
  isBoolean: isBoolean,
  isObject: isObject,
  isString: isString,
  isFunction: isFunction
};

},{}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _like = require('./like.lodash');

var _like2 = _interopRequireDefault(_like);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /** @module ist */
/** @namespace module:ist~spec */


var SPEC_FN_SYMBOL = Symbol('spec-fn-symbol');

var LazySpec = function LazySpec(lazy) {
  _classCallCheck(this, LazySpec);

  this.lazy = lazy;
};

var nullOrCollection = _like2.default.cond([[_like2.default.isEmpty, function () {
  return null;
}], [_like2.default.stubTrue, _like2.default.identity]]);

var isSpec = function isSpec(spec) {
  return Boolean(spec[SPEC_FN_SYMBOL]);
};
var asSpec = function asSpec(specFn) {
  specFn[SPEC_FN_SYMBOL] = true;
  return Object.freeze(specFn);
};

exports.default = {
  /**
   * Usage of function makes sense only if u have spec flow outside of object context
   * or collection context and want to rename output label for validation message
   * @function designate
   * @memberof module:ist~spec
   * 
   * @arg {string} key - key to use instead of 'value' for label to output validation message
   * @arg {function} spec - Accpets spec function
   * 
   * @returns {function} - Spec function which could be used as argument for lib functions
   * 
   * @example
   * 
   * import { spec } from 'istjs'
   * 
   * const asUserSpec = spec.designate('user')
   * 
   * const userModelSpec = spec.compose(
   *   asUserSpec(spec.flow(required)),
   *   spec.of({
   *     username: spec.flow(isNotEmpty, required),
   *     friends: spec.of([spec.lazy(() => userModelSpec)]),
   *   })
   * )
   * 
   * const result = validate(null, { untilFail: true })
   * // [{ message: 'user is required', value: null, args: undefined, path: [] }]
   * 
   */
  designate: _like2.default.curry(function (key, spec) {
    return asSpec(function (value) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var refinedOpts = _extends({}, options, {
        context: options.context || { key: key, current: null, parent: null }
      });

      return spec(value, refinedOpts);
    });
  }),
  /**
   * Function is used to create a lazy evaluate specification item
   * @function lazy
   * @memberof module:ist~spec
   * 
   * @arg {function} getSpecLazy - Expected spec function to be passed 
   * 
   * @returns {LazySpec} - Object which could be used as argument for #compose, #of functions
   * 
   * @example
   *    
   * import { spec } from 'istjs'
   * 
   * const userModelSpec = spec.of({
   *  username: spec.flow(string.isNotEmpty, any.required),
   *  bestFriend: spec.lazy(() => userModelSpec), // returns lazy evaluated spec function
   * })
   * 
   */
  lazy: function lazy(getSpecLazy) {
    if (!_like2.default.isFunction(getSpecLazy)) {
      throw new Error('lazy expects function as an argument');
    }

    return new LazySpec(getSpecLazy);
  },

  /**
   * Function is used to create validation flow
   * @function flow
   * @memberof module:ist~spec
   * 
   * @arg {function[]} ...validators - Accepts validation functions as list of arguments
   * 
   * @returns {function} - Spec function which could be used as argument
   * 
   * @example
   * 
   * import { spec } from 'istjs'
   * 
   * const usernameSpec = spec.flow(
   *  string.isString,
   *  string.match(/^[A-Z][a-z]+\s[A-Z][a-z]+$/)
   *  string.isNotMatch,
   *  any.required
   * )
   * 
   */
  flow: function flow() {
    for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
      validators[_key] = arguments[_key];
    }

    return asSpec(function (value, options) {
      var results = [];

      var _fp$assign = _like2.default.assign({
        context: null,
        untilFail: false
      }, options),
          context = _fp$assign.context,
          untilFail = _fp$assign.untilFail;

      for (var i = 0, l = validators.length; i < l; i += 1) {
        var validator = validators[i];
        var result = validator(value, { context: context });

        if (_like2.default.isArray(result)) {
          results.push({
            result: result,
            value: value,
            context: context
          });
        }

        if (untilFail && results.length > 0) {
          return results;
        }
      }

      return nullOrCollection(results);
    });
  },

  /**
   * Function is used to create a composition between specification functions
   * @function compose
   * @memberof module:ist~spec
   * 
   * @arg {function[]} ...specs - Accpets spec functions as list of arguments
   * 
   * @returns {function} - Spec function which could be used as argument
   * 
   * @example
   * 
   * import { spec } from 'istjs'
   * 
   * const userModelBodySpec = spec.of({
   *  username: spec.flow(string.isNotEmpty, any.required),
   *  bestFriend: spec.lazy(() => userModelBodySpec),
   * })
   * 
   * const userModelRequiredSpec = spec.flow(any.requied)
   * 
   * const fullUserModelSpec = spec.compose(
   *  userModelRequiredSpec,
   *  spec.flow(shape.expectKeys(['username', 'bestFriend'])),
   *  userModelBodySpec,
   * )
   * 
   */
  compose: function compose() {
    for (var _len2 = arguments.length, specs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      specs[_key2] = arguments[_key2];
    }

    if (!specs.every(isSpec)) {
      throw new Error('compose args should be the specs');
    }

    return asSpec(function (value, options) {
      var results = [];
      var extOptions = _like2.default.assign({
        context: null,
        untilFail: false
      }, options);

      for (var i = 0, l = specs.length; i < l; i += 1) {
        var spec = specs[i];
        var result = spec(value, extOptions);

        if (_like2.default.isArray(result)) {
          results.push.apply(results, _toConsumableArray(result));
        }

        if (extOptions.untilFail && results.length > 0) {
          return results;
        }
      }

      return nullOrCollection(results);
    });
  },

  // TODO: mb use template method to support diff forms of spec generators
  /**
   * Function helps to create spec fof complex object such as arrays or shapes (aka objects)
   * @function of
   * @memberof module:ist~spec
   * 
   * @arg {Object|Array} specDescriptor - Accepts object where properties' values must be spec functions
   * or array with only one item that is a spec function
   * 
   * @returns {function} - Spec function which could be used as argument
   * 
   * @example
   * 
   * import { spec } from 'istjs'
   * 
   * const simpleHeroSpec = spec.of({
   *  name: spec.flow(string.isString, string.isNotEmpty, any.required),
   *  abilities: spec.of([spec.flow(any.required)])
   *  address: spec.of({
   *    city: spec.flow(any.required),
   *    // pls note - spec can be complex
   *    streets: spec.of([spec.of({ zip: spec.flow(any.required) })])
   *  })
   * })
   * 
   */
  of: function of(specDescriptor) {
    if (_like2.default.isArray(specDescriptor)) {
      // spec generator for arrays aka collections
      return asSpec(function (collection, options) {
        var results = [];

        var _fp$assign2 = _like2.default.assign({
          context: null,
          untilFail: false
        }, options),
            context = _fp$assign2.context,
            untilFail = _fp$assign2.untilFail;

        var _specDescriptor = _slicedToArray(specDescriptor, 1),
            spec = _specDescriptor[0];

        var specFn = spec.lazy ? spec.lazy() : spec;

        if (!_like2.default.isArray(collection)) {
          return null;
        }

        for (var i = 0, l = collection.length; i < l; i += 1) {
          var value = collection[i];

          var result = specFn(value, {
            context: {
              key: i,
              current: collection,
              parent: context
            },
            untilFail: untilFail
          });

          if (_like2.default.isArray(result)) {
            results.push.apply(results, _toConsumableArray(result));
          }

          if (untilFail && results.length > 0) {
            return results;
          }
        }

        return nullOrCollection(results);
      });
    }

    // spec generator for objects aka shapes
    return asSpec(function (value, options) {
      var results = [];

      var _fp$assign3 = _like2.default.assign({
        context: null,
        untilFail: false
      }, options),
          context = _fp$assign3.context,
          untilFail = _fp$assign3.untilFail;

      var kvPairs = _like2.default.entries(specDescriptor);

      for (var i = 0, l = kvPairs.length; i < l; i += 1) {
        var _kvPairs$i = _slicedToArray(kvPairs[i], 2),
            key = _kvPairs$i[0],
            spec = _kvPairs$i[1];

        var specFn = spec.lazy ? spec.lazy() : spec;

        var result = specFn(_like2.default.get(key, value), {
          context: {
            key: key,
            current: value,
            parent: context
          },
          untilFail: untilFail
        });

        if (_like2.default.isArray(result)) {
          results.push.apply(results, _toConsumableArray(result));
        }

        if (untilFail && results.length > 0) {
          return results;
        }
      }

      return nullOrCollection(results);
    });
  }
};

},{"./like.lodash":4}],6:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.freeze = exports.toValidator = exports.toValidatorWithArgs = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _like = require('./like.lodash');

var _like2 = _interopRequireDefault(_like);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var toValidator = function toValidator(name, isValidFn) {
  return function (value, params) {
    if (value === null || value === undefined) {
      return null;
    }

    return isValidFn(value, params) !== true ? [name] : null;
  };
};

var toValidatorWithArgs = function toValidatorWithArgs(name, isValidFn) {
  return function (args) {
    return function (value, params) {
      if (value === null || value === undefined) {
        return null;
      }

      return isValidFn(args, value, params) !== true ? [name, args] : null;
    };
  };
};

var freeze = function freeze(shape) {
  var resultShape = {};
  var entries = _like2.default.entries(shape);

  entries.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (_like2.default.isObject(value)) {
      resultShape[key] = Object.freeze(freeze(value));
    } else {
      resultShape[key] = value;
    }
  });

  return Object.freeze(resultShape);
};

exports.toValidatorWithArgs = toValidatorWithArgs;
exports.toValidator = toValidator;
exports.freeze = freeze;

},{"./like.lodash":4}],7:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /** @module ist */
/** @namespace module:ist */


var _like = require('./like.lodash');

var _like2 = _interopRequireDefault(_like);

var _keys = require('./defaults/keys');

var _keys2 = _interopRequireDefault(_keys);

var _messages = require('./defaults/messages');

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isValid = function isValid(specFn, value) {
  return _like2.default.isEmpty(specFn(value, { untilFail: true }));
};
var isInvalid = function isInvalid(specFn, value) {
  return !_like2.default.isEmpty(specFn(value, { untilFail: true }));
};
var toTuple = function toTuple(collection) {
  return _like2.default.isArray(collection) ? collection : [];
};

var createValidateFunction = function createValidateFunction(_ref) {
  var untilFail = _ref.untilFail,
      messageFuncs = _ref.messageFuncs;

  var getLabel = _like2.default.getOr('value', 'key');
  var getParent = _like2.default.get('parent');

  var makeFullPathGetter = function makeFullPathGetter(context) {
    var fullpath = [];

    if (!_like2.default.isObject(context)) {
      return function () {
        return [];
      };
    }

    var cicularRefs = new Set();
    var currentContext = context;

    do {
      fullpath.push(currentContext.key);
      cicularRefs.add(currentContext);
      currentContext = getParent(currentContext);
    } while (!(currentContext == null || cicularRefs.has(currentContext)));

    return function () {
      return _like2.default.reverse(fullpath);
    };
  };

  var formatValidationOutput = function formatValidationOutput(specOutput, customMessages) {
    if (specOutput == null) {
      return null;
    }

    var validationResults = [];
    var defaultMessageFunc = messageFuncs[_keys2.default.ANY.UNKNOWN];

    var _loop = function _loop(result, value, context) {
      var _toTuple = toTuple(result),
          _toTuple2 = _slicedToArray(_toTuple, 2),
          name = _toTuple2[0],
          args = _toTuple2[1];

      var messageFn = _like2.default.get(name, customMessages) || messageFuncs[name] || defaultMessageFunc;

      var path = makeFullPathGetter(context);

      validationResults.push({
        message: messageFn({
          label: getLabel(context),
          value: value,
          get path() {
            return path();
          },
          args: args
        }),
        value: value,
        get path() {
          return path();
        },
        args: args
      });
    };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = specOutput[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _ref2 = _step.value;
        var result = _ref2.result;
        var value = _ref2.value;
        var context = _ref2.context;

        _loop(result, value, context);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return validationResults.length > 0 ? validationResults : null;
  };

  return [function (specFn, value) {
    var specOutput = specFn(value, { untilFail: untilFail });
    return formatValidationOutput(specOutput);
  }, function (specFn, options, value) {
    var customMessages = _like2.default.get('customMessages', options);
    var specOutput = specFn(value, { untilFail: untilFail });
    return formatValidationOutput(specOutput, customMessages);
  }];
};

var _createValidateFuncti = createValidateFunction({
  messageFuncs: _messages2.default,
  untilFail: true
}),
    _createValidateFuncti2 = _slicedToArray(_createValidateFuncti, 2),
    validate = _createValidateFuncti2[0],
    validateWithOpts = _createValidateFuncti2[1];

var _createValidateFuncti3 = createValidateFunction({
  messageFuncs: _messages2.default,
  untilFail: false
}),
    _createValidateFuncti4 = _slicedToArray(_createValidateFuncti3, 2),
    validateAll = _createValidateFuncti4[0],
    validateAllWithOpts = _createValidateFuncti4[1];

exports.default = {
  /**
   * Curried function tells whether value is valid
   * @function isValid
   * @static
   * 
   * @arg {function} specFn - generated spec function by: {@link module:ist~spec.flow|flow},
   * {@link module:ist~spec.of|of} or
   * {@link module:ist~spec.compose|compose}
   * @arg {any} value - value to check
   * 
   * @returns {boolean} True if value is valid, othervise false
   * 
   * @example
   * 
   * import { isValid, spec, validators } from 'istjs'
   * 
   * const { string, any } = validators
   * 
   * const usernameSpec = spec.flow(string.isString, string.isNotEmpty, any.required)
   * console.log(isValid(usernameSpec, 'hello')) // true
   * 
   * const isValidUsernameFn = isValid(usernameSpec)
   * console.log(isValidUsernameFn('nope')) // true
   * console.log(isValidUsernameFn(undefined)) // false
   * console.log(isValidUsernameFn(null)) // false
   * console.log(isValidUsernameFn('')) // false
   * 
   */
  isValid: _like2.default.curry(isValid),
  /**
   * Curried function tells whether value is invalid
   * @function isInvalid
   * @static
   * 
   * @arg {function} specFn - generated spec function by: {@link module:ist~spec.flow|flow},
   * {@link module:ist~spec.of|of} or
   * {@link module:ist~spec.compose|compose}
   * @arg {any} value - value to check
   * 
   * @returns {boolean} True if value is invalid, othervise false
   * 
   * @example
   * 
   * import { isInvalid, spec, validators } from 'istjs'
   * 
   * const { string, any } = validators
   * 
   * const usernameSpec = spec.flow(string.isString, string.isNotEmpty, any.required)
   * console.log(isInvalid(usernameSpec, 'hello')) // false
   * 
   * const isInvalidUsernameFn = isInvalid(usernameSpec)
   * console.log(isInvalidUsernameFn('nope')) // false
   * console.log(isInvalidUsernameFn(undefined)) // true
   * console.log(isInvalidUsernameFn(null)) // true
   * console.log(isInvalidUsernameFn('')) // true
   * 
   */
  isInvalid: _like2.default.curry(isInvalid),
  /**
   * Curried function returns validation info if data has errors
   * @function validate
   * @static
   * 
   * @arg {function} specFn - generated spec function by: {@link module:ist~spec.flow|flow},
   * {@link module:ist~spec.of|of} or
   * {@link module:ist~spec.compose|compose}
   * @arg {any} value - value to check
   * 
   * @returns {Object[]|Null} Null if data is valid, otherwise one item array with reason of error
   * 
   * @example
   * 
   * import { validate, spec, validators } from 'istjs'
   * 
   * const { shape, number, string, any } = validators
   * 
   * const usernameSpec = spec.flow(string.isString, string.isNotEmpty, any.required)
   * console.log(validate(usernameSpec, 'hello')) // null
   * 
   * const validateUsername = validate(usernameSpec)
   * 
   * console.log(validateUsername(null)) 
   * // [{
   * //  message: 'value is required', 
   * //  value: null, 
   * //  args: undefined, 
   * //  path: [] // path is computed property
   * // }]
   * 
   * 
   * const adultUserModelSpec = spec.compose(
   *  spec.flow(
   *   shape.isShape,
   *   shape.hasKeys('name', 'age'),
   *   any.required,
   *  ),
   *  spec.of({
   *   name: spec.flow(string.isString, string.isNotEmpty, any.required),
   *   age: spec.flow(number.isNumber, number.ge(18), any.required),
   *  })
   * )
   * 
   * const validateAdultUser = validate(adultUserModelSpec)
   * 
   * const validationResult = validateAdultUser({
   *  name: 'Oliver Darkside',
   *  age: 17,
   * })
   * 
   * console.log(validationResult) 
   * // [{ message: 'age should be greater or equal than 18', value: 17, args: 18, path: ['age'] }]
   * 
   */
  validate: _like2.default.curry(validate),
  /**
   * Curried function with opts, returns validation info if data has errors
   * @function validateWithOpts
   * @static
   * 
   * @arg {function} specFn - generated spec function by: {@link module:ist~spec.flow|flow},
   * {@link module:ist~spec.of|of} or
   * {@link module:ist~spec.compose|compose}
   * @arg {Object} opts - options object
   * @arg {Object} opts.customMessages - overrides validation messages for standart library
   * @arg {any} value - value to check
   * 
   * @returns {Object[]|Null} Null if data is valid, otherwise one item array with reason of error
   * 
   * @example
   * 
   * import { validateWithOpts, spec, validators, ERROR_KEYS } from 'istjs'
   * 
   * const { shape, number, string, any } = validators
   * 
   * const adultUserModelSpec = spec.of({
   *   name: spec.flow(string.isString, string.isNotEmpty, any.required),
   *   age: spec.flow(number.isNumber, number.ge(18), any.required),
   *   address: spec.of({
   *    city: spec.flow(string.isString, any.required),
   *    street: spec.flow(string.isString, any.required),
   *   })
   * })
   * 
   * const validateAdultUser = validateWithOpts(adultUserModelSpec, {
   *   customMessages: {
   *     [ERROR_KEYS.NUMBER.GE]: ({ label, path, value, args }) => 
   *        `${label} can not contain [${value}], because expects something greater or equal than ${args}`
   *   },
   * })
   * 
   * const reasons = validateAdultUser({
   *  name: 'Alice Morgan',
   *  age: 17,
   *  address: {
   *    city: 'London',
   *    street: 'Fitsrovia st.'
   *  }
   * })
   * 
   * console.log(reasons) 
   * // [{
   * //   message: 'age can not contain [17], because expects something greater or equal than 18',
   * //   args: 18,
   * //   value: 17,
   * //   path: ['age'],
   * // }]
   * 
   */
  validateWithOpts: _like2.default.curry(validateWithOpts),
  /**
   * Curried function returns info about all errors if data has them
   * @function validateAll
   * @static
   * 
   * @arg {function} specFn - generated spec function by: {@link module:ist~spec.flow|flow},
   * {@link module:ist~spec.of|of} or
   * {@link module:ist~spec.compose|compose}
   * @arg {any} value - value to check
   * 
   * @returns {Object[]|Null} Null if data is valid, otherwise array with all reasons of error
   * 
   * @example
   * 
   * import { validateAll, spec, validators } from 'istjs'
   * 
   * const { shape, number, string, any } = validators
   * 
   * const simpleSpec = spec.flow(
   *  string.isString,
   *  string.isDigits,
   *  string.isNotEmpty,
   *  any.required
   * )
   * 
   * console.log(validateAll(simpleSpec, 'hello'))
   * // [
   * //   { message: 'value should be a string', value: 'hello', args: undefined, path: [] },
   * //   { message: 'value should contain only digits', value: 'hello', args: undefined, path: [] },
   * // ]
   */
  validateAll: _like2.default.curry(validateAll),
  /**
   * Curried function with opts, returns info about all errors if data has them
   * @function validateAllWithOpts
   * @static
   * 
   * @arg {function} specFn - generated spec function by: {@link module:ist~spec.flow|flow},
   * {@link module:ist~spec.of|of} or
   * {@link module:ist~spec.compose|compose}
   * @arg {Object} opts - options object
   * @arg {Object} opts.customMessages - overrides validation messages for standart library
   * @arg {any} value - value to check
   * 
   * @returns {Object[]|Null} Null if data is valid, otherwise one item array with reason of error
   * 
   * @example
   * 
   * import { validateWithOpts, spec, validators, ERROR_KEYS } from 'istjs'
   * 
   * const { shape, number, string, any } = validators
   * 
   * const simpleSpec = spec.flow(
   *  string.isString,
   *  string.isDigits,
   *  string.isNotEmpty,
   *  any.required
   * )
   * 
   * const extValidateAll = validateAll(simpleSpec, {
   *  customMessages: {
   *   [ERROR_KEYS.STRING.TYPE]: ({ label, value, args, path }) => 'yeah, yeah, yeah ${label} should be a string',
   *  },
   * })
   * 
   * console.log(extValidateAll(simpleSpec, 'hello'))
   * // [
   * //   { message: 'yeah, yeah, yeah value should be a string', value: 'hello', args: undefined, path: [] },
   * //   { message: 'value should contain only digits', value: 'hello', args: undefined, path: [] },
   * // ]
   */
  validateAllWithOpts: _like2.default.curry(validateAllWithOpts),
  /**
   * Function helps to create your own validation functions and define your own validation messages
   * @function createValidateFunction
   * @static
   * 
   * @arg {Object} opts - object with `customMessages`, pls look at the example below
   * @arg {boolean} opts.untilFail - tells validation functions when to stop,
   * if true check validators until first fail, else check all of them
   * @arg {Object<string, function>} opts.messageFuncs - object with {@link module:ist~ERROR_KEYS|error keys} and {@link module:ist~ERROR_MESSAGES|error message function}
   *
   * @returns {function[]} tuple with two functions e.g: [validate, validateWithOpts]
   *
   * @example
   * 
   * import {
   *  spec,
   *  createValidateFunction,
   *  toValidator,
   *  toValidatorWithArgs,
   *  ERROR_KEYS,
   *  ERROR_MESSAGES,
   * } from 'istjs'
   * 
   * const customeErrorKey = 'my.custom.error.key'
   * 
   * const customMessageFunc = {
   *   ...ERROR_MESSAGES,
   *   [ERROR_KEYS.ANY.REQUIRED]: ({ label, args, value, path }) => `${label} is mandatory`,
   *   [customeErrorKey]: ({ label, args, value, path }) => `${label} bla bla bla`,
   * }
   * 
   * const [cvalidate, cvalidateWithOpts] = createValidateFunction({
   *  untilFail: true,
   *  messageFuncs: customMessageFunc,
   * })
   * 
   *
   * const [cvalidateAll, cvalidateAllWithOpts] = createValidateFunction({
   *  untilFail: true,
   *  messageFuncs: customMessageFunc,
   * })
   * 
   * const customValidator = toValidator(customeErrorKey, (value) => Boolean(value))
   * 
   * console.log(cvalidate(spec.flow(customValidator), 0))
   * // [{ messsge: 'value bla bla bla', value: 0, args: undefined, path: [] }]
   *
   */
  createValidateFunction: createValidateFunction
};

},{"./defaults/keys":1,"./defaults/messages":2,"./like.lodash":4}],8:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allow = exports.required = undefined;

var _like = require('../like.lodash');

var _like2 = _interopRequireDefault(_like);

var _keys = require('../defaults/keys');

var _keys2 = _interopRequireDefault(_keys);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var required = function required(value) {
  return value === null || value === undefined ? [_keys2.default.ANY.REQUIRED] : null;
}; /** @module ist */
/** @namespace module:ist~validators/any */


var allow = (0, _utils.toValidatorWithArgs)(_keys2.default.ANY.ALLOW, function (args, value) {
  return _like2.default.includes(value, args);
});

exports.required = required;
exports.allow = allow;

},{"../defaults/keys":1,"../like.lodash":4,"../utils":6}],9:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.length = exports.maxLength = exports.minLength = exports.inRange = exports.every = exports.some = exports.isArray = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /** @module ist */
/** @namespace module:ist~validators/array */


var _like = require('../like.lodash');

var _like2 = _interopRequireDefault(_like);

var _keys = require('../defaults/keys');

var _keys2 = _interopRequireDefault(_keys);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isArray = (0, _utils.toValidator)(_keys2.default.ARRAY.TYPE, _like2.default.isArray);

var minLength = (0, _utils.toValidatorWithArgs)(_keys2.default.ARRAY.MIN_LENGTH, function (minLength, value) {
  return value.length >= minLength;
});
var maxLength = (0, _utils.toValidatorWithArgs)(_keys2.default.ARRAY.MAX_LENGTH, function (maxLength, value) {
  return value.length <= maxLength;
});
var length = (0, _utils.toValidatorWithArgs)(_keys2.default.ARRAY.LENGTH, function (length, value) {
  return value.length === length;
});
var inRange = (0, _utils.toValidatorWithArgs)(_keys2.default.ARRAY.IN_RANGE, function (_ref, value) {
  var _ref2 = _slicedToArray(_ref, 2),
      min = _ref2[0],
      max = _ref2[1];

  var clength = value.length;
  return min <= clength && clength <= max;
});

var every = (0, _utils.toValidatorWithArgs)(_keys2.default.ARRAY.EVERY, function (predicate, value) {
  return _like2.default.every(predicate, value);
});
var some = (0, _utils.toValidatorWithArgs)(_keys2.default.ARRAY.SOME, function (predicate, value) {
  return _like2.default.some(predicate, value);
});

exports.isArray = isArray;
exports.some = some;
exports.every = every;
exports.inRange = inRange;
exports.minLength = minLength;
exports.maxLength = maxLength;
exports.length = length;

},{"../defaults/keys":1,"../like.lodash":4,"../utils":6}],10:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBoolean = undefined;

var _like = require('../like.lodash');

var _like2 = _interopRequireDefault(_like);

var _keys = require('../defaults/keys');

var _keys2 = _interopRequireDefault(_keys);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isBoolean = (0, _utils.toValidator)(_keys2.default.BOOLEAN.TYPE, _like2.default.isBoolean); /** @module ist */
/** @namespace module:ist~validators/boolean */
exports.isBoolean = isBoolean;

},{"../defaults/keys":1,"../like.lodash":4,"../utils":6}],11:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _any = require('./any');

var any = _interopRequireWildcard(_any);

var _boolean = require('./boolean');

var boolean = _interopRequireWildcard(_boolean);

var _number = require('./number');

var number = _interopRequireWildcard(_number);

var _string = require('./string');

var string = _interopRequireWildcard(_string);

var _shape = require('./shape');

var shape = _interopRequireWildcard(_shape);

var _array = require('./array');

var array = _interopRequireWildcard(_array);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  any: any,
  boolean: boolean,
  number: number,
  string: string,
  shape: shape,
  array: array
};

},{"./any":8,"./array":9,"./boolean":10,"./number":12,"./shape":13,"./string":14}],12:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNumber = exports.inRange = exports.le = exports.ge = exports.gt = exports.lt = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /** @module ist */
/** @namespace module:ist~validators/number */


var _like = require('../like.lodash');

var _like2 = _interopRequireDefault(_like);

var _keys = require('../defaults/keys');

var _keys2 = _interopRequireDefault(_keys);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var gt = (0, _utils.toValidatorWithArgs)(_keys2.default.NUMBER.GT, function (min, value) {
  return min < value;
});
var lt = (0, _utils.toValidatorWithArgs)(_keys2.default.NUMBER.LT, function (max, value) {
  return max > value;
});
var ge = (0, _utils.toValidatorWithArgs)(_keys2.default.NUMBER.GE, function (min, value) {
  return min <= value;
});
var le = (0, _utils.toValidatorWithArgs)(_keys2.default.NUMBER.LE, function (max, value) {
  return max >= value;
});
var inRange = (0, _utils.toValidatorWithArgs)(_keys2.default.NUMBER.RANGE, function (_ref, value) {
  var _ref2 = _slicedToArray(_ref, 2),
      min = _ref2[0],
      max = _ref2[1];

  return value >= min && max > value;
});
var isNumber = (0, _utils.toValidator)(_keys2.default.NUMBER.TYPE, _like2.default.isNumber);

exports.lt = lt;
exports.gt = gt;
exports.ge = ge;
exports.le = le;
exports.inRange = inRange;
exports.isNumber = isNumber;

},{"../defaults/keys":1,"../like.lodash":4,"../utils":6}],13:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.expectKeys = exports.forbiddenKeys = exports.allowedKeys = exports.isShape = undefined;

var _like = require('../like.lodash');

var _like2 = _interopRequireDefault(_like);

var _keys = require('../defaults/keys');

var _keys2 = _interopRequireDefault(_keys);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var toSet = function toSet(keys) {
  return new Set(keys);
}; /** @module ist */
/** @namespace module:ist~validators/shape */

var toKeySet = _like2.default.flow(_like2.default.keys, toSet);

var isShape = (0, _utils.toValidator)(_keys2.default.SHAPE.TYPE, _like2.default.isObject);

var allowedKeys = (0, _utils.toValidatorWithArgs)(_keys2.default.SHAPE.ALLOWED_KEYS, _like2.default.overArgs(function (allowedKeysSet, existingKeys) {
  return existingKeys.every(function (key) {
    return allowedKeysSet.has(key);
  });
}, [toSet, _like2.default.keys]));

var forbiddenKeys = (0, _utils.toValidatorWithArgs)(_keys2.default.SHAPE.FORBIDDEN_KEYS, _like2.default.overArgs(function (forbiddenKeys, existingKeySet) {
  return !forbiddenKeys.some(function (key) {
    return existingKeySet.has(key);
  });
}, [_like2.default.identity, toKeySet]));

var expectKeys = (0, _utils.toValidatorWithArgs)(_keys2.default.SHAPE.EXPECTED_KEYS, _like2.default.overArgs(function (expectedKeys, existingKeysSet) {
  return expectedKeys.length === existingKeysSet.size && expectedKeys.every(function (key) {
    return existingKeysSet.has(key);
  });
}, [_like2.default.identity, toKeySet]));

exports.isShape = isShape;
exports.allowedKeys = allowedKeys;
exports.forbiddenKeys = forbiddenKeys;
exports.expectKeys = expectKeys;

},{"../defaults/keys":1,"../like.lodash":4,"../utils":6}],14:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.match = exports.isISODate = exports.isAlphanum = exports.isDigits = exports.isEmail = exports.isNotEmpty = exports.isString = undefined;

var _like = require('../like.lodash');

var _like2 = _interopRequireDefault(_like);

var _keys = require('../defaults/keys');

var _keys2 = _interopRequireDefault(_keys);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DIGITS_PATTERN = /^\d+$/; /** @module ist */
/** @namespace module:ist~validators/string */

var ALPHANUM_PATTERN = /^[a-zA-Z0-9]+$/;
var EMAIL_PATTERN = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var ISO_DATE_PATTERN = /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/;

var isString = (0, _utils.toValidator)(_keys2.default.STRING.TYPE, _like2.default.isString);
var isNotEmpty = (0, _utils.toValidator)(_keys2.default.STRING.EMPTY, function (value) {
  return value !== '';
});

var isEmail = (0, _utils.toValidator)(_keys2.default.STRING.EMAIL, function (value) {
  return EMAIL_PATTERN.test(value);
});
var isDigits = (0, _utils.toValidator)(_keys2.default.STRING.DIGITS, function (value) {
  return DIGITS_PATTERN.test(value);
});
var isAlphanum = (0, _utils.toValidator)(_keys2.default.STRING.ALPHANUM, function (value) {
  return ALPHANUM_PATTERN.test(value);
});
var isISODate = (0, _utils.toValidator)(_keys2.default.STRING.ISO_DATE, function (value) {
  return ISO_DATE_PATTERN.test(value);
});

var match = (0, _utils.toValidatorWithArgs)(_keys2.default.STRING.MATCH, function (pattern, value) {
  return pattern.test(value);
});

exports.isString = isString;
exports.isNotEmpty = isNotEmpty;
exports.isEmail = isEmail;
exports.isDigits = isDigits;
exports.isAlphanum = isAlphanum;
exports.isISODate = isISODate;
exports.match = match;

},{"../defaults/keys":1,"../like.lodash":4,"../utils":6}]},{},[3])(3)
});
